import { FunctionalComponent } from 'interfaces/components';
import { classNames } from 'utils/classNames';

interface IBaseTextProps extends FunctionalComponent {
  className?: string;
  bolded?: boolean;
  gopher?: boolean;
  centered?: boolean;
  // Render a different element with the same styling, e.g. a button label
  // that looks like an H5 but is not a heading (WHIT-394, heading-order).
  as?: React.ElementType;
}

export const H1: React.FC<IBaseTextProps> = ({
  children,
  className,
  bolded,
  gopher,
  centered,
  as: Tag = 'h1',
}) => (
  <Tag
    className={classNames(
      className,
      'text-[2.5rem] leading-[2.625rem]',
      bolded && 'font-bold',
      gopher && 'tt-gopher text-tt-heading',
      centered && 'text-center',
    )}>
    {children}
  </Tag>
);
export const H2: React.FC<IBaseTextProps> = ({
  children,
  className,
  bolded,
  gopher,
  centered,
  as: Tag = 'h2',
}) => (
  <Tag
    className={classNames(
      className,
      'text-[1.75rem] leading-[1.875rem]',
      bolded && 'font-bold',
      gopher && 'tt-gopher text-tt-heading',
      centered && 'text-center',
    )}>
    {children}
  </Tag>
);
export const H3: React.FC<IBaseTextProps> = ({
  children,
  className,
  bolded,
  gopher,
  centered,
  as: Tag = 'h3',
}) => (
  <Tag
    className={classNames(
      className,
      'text-[1.375rem]',
      bolded && 'font-bold',
      gopher && 'tt-gopher text-tt-heading',
      centered && 'text-center',
    )}>
    {children}
  </Tag>
);
export const H4: React.FC<IBaseTextProps> = ({
  children,
  className,
  bolded,
  gopher,
  centered,
  as: Tag = 'h4',
}) => (
  <Tag
    className={classNames(
      className,
      'text-[1.125rem]',
      bolded && 'font-bold',
      gopher && 'tt-gopher text-tt-heading',
      centered && 'text-center',
    )}>
    {children}
  </Tag>
);
export const H5: React.FC<IBaseTextProps> = ({
  children,
  className,
  bolded,
  gopher,
  centered,
  as: Tag = 'h5',
}) => (
  <Tag
    className={classNames(
      className,
      'text-[1rem]',
      bolded && 'font-bold',
      gopher && 'tt-gopher text-tt-heading',
      centered && 'text-center',
    )}>
    {children}
  </Tag>
);
export const H6: React.FC<IBaseTextProps> = ({
  children,
  className,
  bolded,
  gopher,
  centered,
  as: Tag = 'h6',
}) => (
  <Tag
    className={classNames(
      className,
      'text-[0.75rem]',
      bolded && 'font-bold',
      gopher && 'tt-gopher text-tt-heading',
      centered && 'text-center',
    )}>
    {children}
  </Tag>
);
export const P: React.FC<IBaseTextProps> = ({
  children,
  className,
  bolded,
  gopher,
  centered,
}) => (
  <p
    className={classNames(
      className,
      'text-[0.875rem] leading-[1.125rem]',
      bolded && 'font-bold',
      gopher && 'tt-gopher text-tt-heading',
      centered && 'text-center',
    )}>
    {children}
  </p>
);

export default H1;
